import type { FormEvent } from "react";
import type { AnyRouter } from "@tanstack/react-router";

// The router instance, set once in main.tsx, so plain functions (form actions) can navigate.
let router: AnyRouter | null = null;

export function setRouter(r: AnyRouter) {
  router = r;
}

/** Splits an app href ("/w/x/journal?view=month#top") into router navigation options. */
export function parseHref(href: string) {
  const u = new URL(href, "http://app");
  const search = Object.fromEntries(u.searchParams.entries());
  return { to: u.pathname, search, hash: u.hash ? u.hash.slice(1) : undefined };
}

/** Navigates to an app href. */
export function go(href: string, opts: { replace?: boolean } = {}) {
  if (!router) throw new Error("router not set");
  const { to, search, hash } = parseHref(href);
  return router.navigate({ to, search, hash, replace: opts.replace });
}

export function currentRouter() {
  if (!router) throw new Error("router not set");
  return router;
}

/** onSubmit for a GET search form: navigates to path with the form's non-empty fields as the query. */
export function searchSubmit(path: string) {
  return (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(e.currentTarget)) if (typeof v === "string" && v !== "") p.set(k, v);
    const s = p.toString();
    void go(s ? `${path}?${s}` : path);
  };
}
